<template>
	<div>
		<Title title="Dados do Aluno" />
		<b-row class="mt-3">
			<input-text
				v-model="dados.nomeAluno"
				class="col-4"
				label="Nome completo (como está no documento oficial)"
				:disabled="true"
			/>
			<input-text
				v-model="turmaFormatada"
				class="col-4"
				placeholder=""
				label="Turma"
				:disabled="true"
			/>
			<input-text
				v-model="idiomaDescricaoFormatado"
				class="col-4"
				label="Idioma do curso"
				:disabled="true"
			/>
			<!-- <input-text
                v-model="dados.periodoLetivoDescricao"
                class="col-4"
                label="Período letivo"
                :disabled="true"
            /> -->
		</b-row>
	</div>
</template>
<script>
import Title from "@/components/Title.vue";
import InputText from "@/components/inputs/InputText.vue";
export default {
	props: ["dados"],
	data() {
		return {};
	},
	computed: {
		turmaFormatada: {
			get() {
				return this.dados.turma && this.dados.anoLetivo
					? `${this.dados.turma} (${this.dados.anoLetivo})`
					: this.dados.turma || "";
			},
			set() {},
		},
		idiomaDescricaoFormatado: {
			get() {
				return this.dados.idiomaDescricao === "0"
					? ""
					: this.dados.idiomaDescricao;
			},
			set(novoValor) {
				this.$emit("update:idiomaDescricao", novoValor);
			},
		},
	},
	components: {
		Title,
		InputText,
	},
};
</script>
